// --- React
import { useMemo } from 'react';
// --- Redux
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
// --- Actions
import * as allActions from './actions';

export function useJobMetricActions() {
    const dispatch = useDispatch();

    // Bind all action creators to the dispatch function
    return useMemo(() => bindActionCreators(allActions, dispatch), [dispatch]);
}
